var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFasterAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_1309)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 40.5105C80 62.6017 62.0913 80.5105 40 80.5105C17.9087 80.5105 0 62.6017 0 40.5105C0 18.4192 17.9087 0.510498 40 0.510498C62.0913 0.510498 80 18.4192 80 40.5105Z",
    fill: "#FFE3CC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_371_1309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 73,
    height: 73
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02441 76.5605V4.5105H76.0519V76.5605H4.02441Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_371_1309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1125 46.9136C38.3608 48.6665 33.2556 61.0409 33.2556 61.0409C32.5076 62.4017 33.6284 63.3896 36.1765 62.0953L45.3371 57.0993C50.2723 54.3563 51.2264 53.6399 51.1611 48.0559L50.243 41.4626C49.9287 39.204 48.2378 38.7894 46.485 40.5422L40.1125 46.9136V46.9136ZM34.453 41.2542C32.7002 43.007 20.3258 48.1111 20.3258 48.1111C18.965 48.8602 17.9771 47.7394 19.2714 45.1901L24.2674 36.0295C27.0103 31.0955 27.7268 30.1403 33.3119 30.2056L39.9052 31.1237C42.1638 31.438 42.5772 33.13 40.8256 34.8817L34.453 41.2542Z",
    fill: "#B85756"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.89 46.7593C33.6069 41.0435 38.4091 42.7873 38.4091 42.7873C38.4091 42.7873 40.1529 47.5895 34.4371 53.3053C28.7213 59.0222 19.465 63.1733 18.7441 62.4524C18.0456 61.7528 22.1742 52.4751 27.89 46.7593",
    fill: "#D5915B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6695 41.9796C38.3853 36.2638 43.1875 38.0088 43.1875 38.0088C43.1875 38.0088 44.9324 42.8098 39.2166 48.5268C33.4997 54.2425 24.2445 58.3936 23.5236 57.6727C22.824 56.9743 26.9537 47.6954 32.6695 41.9796",
    fill: "#F0CB83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.832 52.8784C37.2094 52.0696 37.5879 51.2788 37.954 50.5466C41.8224 50.2041 46.6606 49.0641 50.8647 45.9235L51.1485 47.9613C46.4657 51.5852 40.9381 52.6598 36.832 52.8784Z",
    fill: "#974D4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8094 52.9245C34.4636 52.9212 34.1358 52.9133 33.8271 52.9009C34.6999 52.3115 35.5502 51.6896 36.3764 51.0366C35.8987 51.7017 35.3751 52.3325 34.8094 52.9245Z",
    fill: "#AE7A51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8266 52.9009C33.7008 52.8966 33.575 52.8909 33.4492 52.884L36.3229 50.6491C36.5088 50.6423 36.6991 50.6333 36.8906 50.6221C35.9042 51.4276 34.8818 52.188 33.8266 52.9009V52.9009ZM30.5643 50.0002C30.5183 49.0802 30.5111 48.1587 30.5429 47.2381C30.5823 48.3612 30.6713 49.2387 30.7389 49.7761L30.5643 50.0002Z",
    fill: "#C1A56E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1098 43.9803C44.3119 52.7792 30.8245 50.3708 30.8245 50.3708C30.8245 50.3708 28.4172 36.8845 37.2162 28.0867C46.0141 19.2877 59.3438 18.3516 61.0943 20.1022C62.7908 21.7998 61.9088 35.1824 53.1098 43.9803",
    fill: "#DEDECA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0039 58.5829C25.7662 58.5829 25.5195 58.4703 25.2491 58.1999C25.0182 57.969 24.9022 57.7561 24.874 57.5499C26.3655 57.1038 28.8854 55.9514 31.6036 54.3192L27.6384 57.4035C27.029 58.0129 26.539 58.5829 26.0039 58.5829",
    fill: "#AE7A51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8745 57.5499C24.7934 56.9721 25.3972 56.4595 26.0461 55.8107L30.5644 50.0002C30.6478 51.628 30.8246 52.6238 30.8246 52.6238C30.8246 52.6238 31.8204 52.8018 33.4493 52.884L31.6042 54.3192C28.8859 55.9515 26.366 57.1039 24.8745 57.5499",
    fill: "#C1A56E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4494 52.884C31.8205 52.8018 30.8247 52.6238 30.8247 52.6238C30.8247 52.6238 30.6478 51.628 30.5645 50.0002L30.7391 49.7761C30.7875 50.1613 30.8247 50.3708 30.8247 50.3708C30.8247 50.3708 32.5121 50.6727 35.0828 50.6727C35.4759 50.6727 35.8905 50.6649 36.323 50.6491L33.4494 52.884",
    fill: "#9F895E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.083 50.6727C32.5123 50.6727 30.8249 50.3708 30.8249 50.3708C30.8249 50.3708 30.7877 50.1613 30.7393 49.776L37.1974 41.4727C37.8068 40.8633 39.8255 40.2933 41.3012 40.2933C41.9557 40.2933 42.5031 40.4059 42.7735 40.6763C43.6533 41.5561 42.8569 45.3715 41.9771 46.2513L36.3232 50.6491C35.8907 50.6648 35.4761 50.6727 35.083 50.6727",
    fill: "#B3B2A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6389 55.1505C26.7591 56.0303 26.1294 56.8267 25.2496 55.9469C24.3698 55.0671 25.1663 54.4374 26.046 53.5576L37.1971 39.2197C38.0769 38.34 41.8934 37.5435 42.7732 38.4233C43.653 39.3031 42.8566 43.1196 41.9768 43.9994L27.6389 55.1505",
    fill: "#B85756"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5698 39.5554C47.3746 39.5551 46.2285 39.0801 45.3836 38.2347C44.5387 37.3894 44.0642 36.243 44.0645 35.0478C44.0648 33.8526 44.5398 32.7065 45.3852 31.8616C46.2305 31.0166 47.3769 30.5421 48.5721 30.5424C49.7673 30.5427 50.9134 31.0178 51.7583 31.8632C52.6033 32.7085 53.0778 33.8549 53.0775 35.0501C53.0772 36.2453 52.6021 37.3914 51.7567 38.2363C50.9114 39.0812 49.765 39.5557 48.5698 39.5554V39.5554ZM54.9424 30.93C54.3448 30.93 53.7718 30.6926 53.3493 30.2701C52.9267 29.8476 52.6894 29.2745 52.6894 28.677C52.6894 28.0795 52.9267 27.5064 53.3493 27.0839C53.7718 26.6614 54.3448 26.424 54.9424 26.424C55.5399 26.424 56.1129 26.6614 56.5354 27.0839C56.958 27.5064 57.1953 28.0795 57.1953 28.677C57.1953 29.2745 56.958 29.8476 56.5354 30.2701C56.1129 30.6926 55.5399 30.93 54.9424 30.93Z",
    fill: "#B3B2A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7562 35.9822C51.3377 36.4007 50.8409 36.7326 50.2941 36.959C49.7473 37.1854 49.1613 37.3019 48.5695 37.3019C47.9777 37.3018 47.3917 37.1852 46.845 36.9587C46.2983 36.7322 45.8015 36.4002 45.3831 35.9817C44.9647 35.5632 44.6328 35.0664 44.4064 34.5196C44.1799 33.9728 44.0634 33.3868 44.0635 32.795C44.0635 32.2032 44.1801 31.6172 44.4067 31.0705C44.6332 30.5238 44.9652 30.027 45.3837 29.6086C46.2289 28.7635 47.3751 28.2889 48.5703 28.289C49.7655 28.2891 50.9117 28.764 51.7568 29.6092C52.6018 30.4544 53.0765 31.6006 53.0764 32.7958C53.0763 33.991 52.6014 35.1372 51.7562 35.9822V35.9822ZM56.5347 28.0169C56.3269 28.232 56.0783 28.4037 55.8034 28.5218C55.5286 28.6398 55.2329 28.702 54.9338 28.7046C54.6346 28.7072 54.338 28.6502 54.0611 28.5369C53.7842 28.4236 53.5327 28.2563 53.3211 28.0448C53.1096 27.8333 52.9423 27.5817 52.829 27.3048C52.7157 27.0279 52.6587 26.7313 52.6613 26.4321C52.6639 26.133 52.7261 25.8373 52.8441 25.5625C52.9622 25.2876 53.1339 25.039 53.349 24.8312C53.774 24.4208 54.3431 24.1937 54.9338 24.1988C55.5245 24.2039 56.0896 24.4409 56.5073 24.8586C56.925 25.2763 57.162 25.8414 57.1671 26.4321C57.1722 27.0228 56.9451 27.5919 56.5347 28.0169Z",
    fill: "#4C5665"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_1309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.510498)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasterAppIcon);
export default __webpack_public_path__ + "static/media/fasterAppIcon.b9ef7d48.svg";
export { ForwardRef as ReactComponent };